import store from '../store';
import APIService from './APIService';
import config from '../../config';

const baseUrl = config.baseUrlForApplicationManagerService;

export default class AppManagerService extends APIService {
  /**
   *
   * @param {string} sourceType
   * @returns  {AxiosPromise<any>}
   */
  static createVaultApplication(sourceType) {
    const url = `${baseUrl}/vault/applications`;
    const { currentlySelectedOrgId, currentOrgData } = store.state;
    const body = {
      orgId: currentlySelectedOrgId,
      tenantId: currentOrgData.tenantId,
      sourceType
    };
    return this.post(url, body);
  }
}
